import { createReducer } from "typesafe-actions";
import update from "immutability-helper";
import { setAlert } from "./actions";
const initialState = {};
export const kAlertReducer = createReducer(initialState).handleAction(setAlert, (state, action) => update(state, {
    msg: { $set: action.payload.msg },
    type: { $set: action.payload.type },
    hidden: { $set: Math.random() },
}));
